import { render, staticRenderFns } from "./SelectVerification.vue?vue&type=template&id=22f427c0&lang=html"
import script from "./SelectVerification.vue?vue&type=script&lang=js"
export * from "./SelectVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports